var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0234375 4.23438C0.0234375 4.67188 0.335938 4.98438 0.773438 4.98438H12.6797L11.7422 5.85938C11.4297 6.17188 11.4297 6.64062 11.7422 6.95312L12.0547 7.26562C12.3672 7.57812 12.8359 7.57812 13.1172 7.26562L15.7109 4.70312C16.1172 4.32812 16.1172 3.67188 15.7109 3.29688L13.1172 0.734375C12.8359 0.421875 12.3672 0.421875 12.0547 0.734375L11.7422 1.04688C11.4297 1.35938 11.4297 1.82812 11.7422 2.14062L12.6797 2.98438H0.773438C0.335938 2.98438 0.0234375 3.32812 0.0234375 3.73438V4.23438ZM15.2734 8.98438H3.33594L4.27344 8.14062C4.58594 7.82812 4.58594 7.35938 4.27344 7.04688L3.96094 6.73438C3.64844 6.42188 3.17969 6.42188 2.89844 6.73438L0.304688 9.29688C-0.101562 9.67188 -0.101562 10.3281 0.304688 10.7031L2.89844 13.2656C3.17969 13.5781 3.64844 13.5781 3.96094 13.2656L4.27344 12.9531C4.58594 12.6406 4.58594 12.1719 4.27344 11.8594L3.33594 10.9844H15.2734C15.6797 10.9844 16.0234 10.6719 16.0234 10.2344V9.73438C16.0234 9.32812 15.6797 8.98438 15.2734 8.98438Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.857f589047fc3301ab90cab2377e886d.svg";
export { ForwardRef as ReactComponent };